











































import Vue from 'vue';
import { ElMessageBoxOptions } from 'element-ui/types/message-box';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { UPDATE_BASIC_EDIT } from '@/main/store/listEditTypes';
import { ApiNotificationOption, getMessageType, MessageTypeStatus, showAlert, showNotification } from '@/main/utils/notifications';
import { mapMutationsDvm } from '@/main/pages';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import DropButtons from '@/modules/servis/zakazka/components/DropButtons.vue';

import { ScreenSize } from '@/main/components/constants';

import { SignalRConnection, SignalRResponsesEnum } from '#services/signalR';
import DmsPdfDialog from '#components/DmsPdfDialog.vue';


import { Edl } from '../../edl';
import { store } from '../store/edit';
import { NDPRIJEMKA_STATUS } from '../constants';
import { apiProvider as ndPrijemkaApiProvider, prijemkaTiskUrl, goodReceivedNoteReportUrl, partsPurInvoiceUrl } from '../api';
import { EditableStatus, convertToObjects } from '@/main/utils/table';
export default PageModeMixin.extend({
	name: 'NdPrijemkaButtons',
	components: {
		DmsPdfDialog,
		DropButtons,
	},
	props: {
		isZpracujMode: { type: Boolean, default: false },
		storeUri: String,
		isModified: Boolean,
	},
	data() {
		return {
			lstPartsReceiptButtons: [
				{ labelKey: '' as string | null, click: '' as string | null, disable: '' as string | boolean | null, exist: true as boolean | null, text: '' as string | null },
			],
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			prijemkaTiskUrl,
			goodReceivedNoteReportUrl,
			partsPurInvoiceUrl,
			showTiskDialog: false,
			showGrnTiskDialog: false,
			showInvoiceTiskDialog: false,
			customDialog: {
				showDialog: false,
				showYes: false,
				showNo: false,
				showCancel: false,
			},
			signalR: new SignalRConnection('NdPrijemkaHub'),
			dialogMessage: '',
			SignalRResponsesEnum,
			showArrow: false,
		};
	},
	computed: {
		...genVuexComputeds(store),
		disableUzavreni(): boolean {
			return this.Status! > NDPRIJEMKA_STATUS.UZAV_KE_KOREKCI || this.isViewMode || !(this.PrijemkaId! > 0);
		},
		prijemkaTiskFilter(): object {
			return {
				PrijemkaId: this.PrijemkaId,
				PRInvoiceFlag: this.PRInvoiceFlag,
				NdpohybdoklId: this.NdpohybdoklId,
				UzavrenaPrp:
			this.Status === NDPRIJEMKA_STATUS.UZAV_KE_KOREKCI || this.Status === NDPRIJEMKA_STATUS.UZAVRENA || this.UzavreniDat || this.NcKorDat ? 1 : 0,
				PrintDialog: true,
				ReportType: 'pdf',
			};
		},
		invoiceTiskFilter(): object {
			return {
				PrijemkaId: this.PrijemkaId,
				PRInvoiceFlag: this.PRInvoiceFlag,
				NdpohybdoklId: this.NdpohybdoklId,
				PrintDialog: true,
				ReportType: 'pdf',
			};
		},
		goodReceivedNoteReportFilter(): object {
			return {
				PrijemkaId: this.PrijemkaId,
				ReportType: 'pdf',
			};
		},
		isDobropisDisabled(): boolean {
			return this.isZpracujMode && !!this.CanMakeDobropis && this.Status === NDPRIJEMKA_STATUS.UZAVRENA;
		},
		isPrintInvoiceVisible(): boolean {
			return this.PrijemkaId! > 0 && this.Status === NDPRIJEMKA_STATUS.UZAVRENA && this.loggedUser.DmsSys.PROrdersPrp!;
		},
		isCancelButtonVisible(): boolean {
			return this.PrijemkaId! > 0 && this.PrijemkaPfx !== null && this.Status === NDPRIJEMKA_STATUS.UZAVRENA && this.PRInvoicePfx === null && this.loggedUser.DmsSys.PROrdersPrp!;
		},
		partsReturnButtons(): object {
			this.lstPartsReceiptButtons =			[
				{ labelKey: 'cmdTiskPrijemky', text: '', click: 'tiskPrijemky', disable: false, exist: true },
				{ labelKey: 'cmdTiskEan', text: '', click: '', disable: false, exist: true },
				{ labelKey: 'cmdViewUzavreni', text: '', click: 'uzavreni', disable: this.disableUzavreni, exist: true },
				{ labelKey: 'cmdDobropis', text: '', click: '', disable: !this.isDobropisDisabled, exist: true },
				{ labelKey: null, text: this.LocalizeFormular('EdlNd'), click: 'openEdl', disable: false, exist: !!this.EdlPrp },
				{ labelKey: 'CANCEL_PR_RECEIPT', text: '', click: 'cancelPrReceipt', disable: false, exist: this.isCancelButtonVisible },
				{ labelKey: 'PRINT_PR_INVOICE', text: '', click: 'prInvoiceClick', disable: false, exist: this.isPrintInvoiceVisible },
			];
			return this.lstPartsReceiptButtons
				.filter((item) => ((item.labelKey !== undefined && item.labelKey != null)) && item.exist)
				.map((item) => ({
					labelKey: item.labelKey,
					click: () => { this.call(item.click); },
					exist: item.exist,
					disable: item.disable,
					text: item.text,
				}));
		},
		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},
	},
	async mounted() {
		this.signalR.listenTo('ZobrazDialogAnoNeCancel', (message: string) => {
			this.endLoading();
			this.customDialog.showYes = true;
			this.customDialog.showCancel = true;
			this.customDialog.showNo = true;
			this.dialogMessage = message;
			this.customDialog.showDialog = true;
		});
		this.signalR.listenTo('ZobrazDialogAnoNe', (message: string) => {
			this.endLoading();
			this.customDialog.showYes = true;
			this.customDialog.showCancel = false;
			this.customDialog.showNo = true;
			this.dialogMessage = message;
			this.customDialog.showDialog = true;
		});
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	async created() {
		await this.signalR.start();
	},
	async beforeDestroy() {
		await this.signalR.stop();
	},

	methods: {
		...mapMutationsDvm(store.mutations),
		tiskPrijemky() {
			if (this.dmsSys.IndiaCFDPrp) {
				this.showGrnTiskDialog = true;
			} else {
				this.showTiskDialog = true;
			}
		},
		prInvoiceClick() {
			this.PRInvoiceFlag = true;
			if (this.dmsSys.IndiaCFDPrp) {
				this.showInvoiceTiskDialog = true;
			} else {
				this.showTiskDialog = true;
			}
		},
        partsValidation() {
            const parts = convertToObjects(this.dependentTables.NdPrijemkaPolozky);
               for (let i = 0; i < parts.length; i++) {
                  const partInfo = parts[i];
                    if (partInfo.UnitCostPrice === null || partInfo.UnitCostPrice <= 0 || partInfo.ReceiptQuantity === null || partInfo.ReceiptQuantity <= 0) {
                        this.showErrorAlert({
                        message: this.LocalizeChyboveHlasky('RECEIPTQTY_UNITCOST_GREATER_THAN_ZERO'),
                        options: { type: 'error' },
                        localizeMessage: false,
                    });
                return false;
            }
        }
        return true;
    },
		async uzavreni() {
			if(this.UzavreniDat != null) {
				showAlert({
					message: this.LocalizeChyboveHlasky('GRN_CLOSED'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			if (!this.partsValidation()) return;
			this.startLoading();
			//if (this.isModified) await this.$emit('save', false);//UzavreniPrijemky already saving updated data
			const dto = await this.signalR.mainCall('UzavreniPrijemky', this.edit);
			this.edit.IsGRNClosed = true;
			this.endLoading();
			// TODO: z prochazeni erroru udelat mixin na zobrazovani erroru
			const UserMessagesList = dto?.UserMessageList;
			if (UserMessagesList !== null && UserMessagesList !== undefined && UserMessagesList.length > 0) {
				const message = UserMessagesList.map((item: ApiNotificationOption) => item.Message).join('<br>');
				const alert = {
					title: UserMessagesList[0].Title,
					message,
					options: {
						type: getMessageType(UserMessagesList[0].Type),
					} as ElMessageBoxOptions,
				};
				if (message.trim() !== '' && message.trim() !== '<br>') {
					if (UserMessagesList[0].Type === MessageTypeStatus.OTHER) {
						showNotification({
							title: 'API Error',
							message,
							type: 'error',
						});
					} else {
						showAlert(alert);
					}
				} else {
					showAlert({
						message: this.LocalizeChyboveHlasky('GRN_CLOSED'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				}
				return;
			}
			if (dto?.PrijemkaId) {
				await this.$store.commit(`${this.storeUri}/${UPDATE_BASIC_EDIT}`, { data: dto });
				this.$emit('refresh-doklady');
				this.updateEditHash({ data: dto });
				// On successful GRN Closure, Left-to-deliver qty needs to be updated
				ndPrijemkaApiProvider.updatePurchaseOrderItemsCount(this.edit.PrijemkaId!);
				this.PRInvoiceFlag = null;
				await ndPrijemkaApiProvider.generateInvoice(this.edit);
				// this.tiskPrijemky(); //commented this line with respect to current market requirements indian cfd should not be visible 
				showAlert({
					message: this.LocalizeChyboveHlasky('GRN_CLOSED'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				(this.$refs.table as any).refreshLayout();
			}
		},
		dobropis() {
			// TODO
			this.$emit('refresh-doklady');
		},
		async sendResponse(val: SignalRResponsesEnum) {
			this.customDialog.showDialog = false;
			this.startLoading();
			await this.signalR.acknowledgeCall(val);
		},
		openEdl() {
			openEdit(Edl.name, PageMode.EDIT, { id: this.EdlId! });
		},
		autoClosePrOrder(PrijemkaId: number) {
			ndPrijemkaApiProvider.autoClosePrOrder(PrijemkaId);
		},
		cancelPrReceipt() {
			if (this.Remarks === null) {
				showAlert({
					message: this.LocalizeChyboveHlasky('errRemarks'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			const isPRCancelled = ndPrijemkaApiProvider.cancelPrReceipt(this.edit);
			if (!isPRCancelled) {
				showAlert({
					message: this.LocalizeChyboveHlasky('errCancelPR'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
		},
		markReportAsPrinted(reportType:string) {
			ndPrijemkaApiProvider.markReportAsPrinted(this.PrijemkaId, reportType);
		},
		call(method:any) {
			(this as { [key:string]:any })[method]();
		},
		scrollNavbarRight() {
			const content = document.querySelector('.button-box');
			if (content !== null) {
				content.scrollLeft += 50;
			}
		},
		scrollNavbarLeft() {
			const content = document.querySelector('.button-box');
			if (content !== null) {
				content.scrollLeft -= 50;
			}
		},

	},
});
